import axios from 'axios'
import qs from 'qs'
import router from '../router/index'
import {
  Message
} from 'element-ui'
let messageInstance = null;

function showMessage(value) {
  // 如果弹窗已存在先关闭
  if (messageInstance) {
    messageInstance.close();
  }
  messageInstance = Message({
    showClose: true,
    message: value,
    type: 'error',
    duration: 3500
  })
}

// axios.defaults.baseURL = "https://rmtzx.daixianxinwen.com/"; //测试
axios.defaults.baseURL = "https://rmtzx.daixianxinwen.com/";

axios.defaults.timeout = 15000
axios.defaults.withCredentials = true

/* 请求拦截器 */
axios.interceptors.request.use(config => { //在此处统一配置公共参数
  let params = {
    siteId: 1
  }
  // get请求
  if (config.method === 'get' && config.url != undefined) {
    for (let key in config.params) {
      params[key] = config.params[key] //添加进参数列表
    }
    config.params = params
  }
  // post请求
  if (config.method === 'post' && config.url != undefined) {
    for (let key in config.data) {
      params[key] = config.data[key] //添加进参数列表
    }
    config.data = qs.stringify(params) //序列化
  }
  return config
}, error => {
  Promise.reject(error) // 错误提示
})


/** 响应拦截器 */
axios.interceptors.response.use(response => {
    let res = response.data
    switch (res.code) {
      case undefined:
        break
      case 1:
        break
      case 0:
        break
      case '304':
        break
      default:
        showMessage(res.msg)
        break
    }
    return response.data
  },
  error => {
    showMessage('服务器响应失败')
    return Promise.reject(error)
  }
)

export default axios



// WEBPACK FOOTER //
// ./src/api/fetch.js